import React from "react";
import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";


const ClinicSearch = ({
  searchTerm,
  selectedClinic,
  filteredClinics,
  handleSearchChange,
  handleClinicSelect,
  searchContainerRef,
}) => {
  const { t } = useTranslation(); 

  return (
    <div className="clinic-search-section" ref={searchContainerRef}>
      <label htmlFor="clinic-search">{t("patient_view_clinic.search_for_clinic")}:</label>
      <input
        type="text"
        id="clinic-search"
        className="clinic-search-input"
        placeholder={t("patient_view_clinic.type_to_search")}
        value={searchTerm || selectedClinic?.clinic_name || ""}
        onChange={handleSearchChange}
      />

      {/* Clinic results list */}
      {searchTerm && filteredClinics.length > 0 && (
        <ul className="clinic-search-results">
          {filteredClinics.map((clinic, index) => (
            <li
              key={`${clinic.id}-${index}`}
              className={`clinic-search-item ${
                selectedClinic && selectedClinic.id === clinic.id ? "selected" : ""
              }`}
              onClick={() => handleClinicSelect(clinic)}
            >
              {clinic.clinic_name}
            </li>
          ))}
        </ul>
      )}

      {/* Only show "No clinics found" if no clinics match the search term */}
      {searchTerm && filteredClinics.length === 0 && !selectedClinic && (
        <p className="no-clinics-found">{t("patient_view_clinic.no_clinics_found")}</p>
      )}
    </div>
  );
};

ClinicSearch.propTypes = {
  searchTerm: PropTypes.string,
  selectedClinic: PropTypes.shape({
    clinic_id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    clinic_name: PropTypes.string.isRequired,
  }),  
  filteredClinics: PropTypes.array,
  handleSearchChange: PropTypes.func.isRequired,
  handleClinicSelect: PropTypes.func.isRequired,
  searchContainerRef: PropTypes.object.isRequired,
};

export default ClinicSearch;
